import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconDownloadGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        fill={fillColor}
        d="M19 9H15V3H9V9H5L12 16L19 9ZM5 18V20H19V18H5Z"
      />
    </g>
  );
};
export const IconDownloadSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...(props.svg ?? {})}
    >
      <IconDownloadGroup {...props} />
    </svg>
  );
};
